import { User, Calendar, Clock, Eye } from "lucide-react";

interface ArticleMetaInfoProps {
  post: {
    author?: {
      name: string;
    };
    date?: string;
    content?: string;
    meta?: Record<string, any>;
    customFields?: Record<string, any>;
  };
}

function stripHtml(html?: string): string {
  if (!html) return "";
  return html.replace(/<[^>]+>/g, "").replace(/\s+/g, " ").trim();
}

export function ArticleMetaInfo({ post }: ArticleMetaInfoProps = { post: undefined as any }) {
  if (!post) {
    post = {} as any;
  }

  const authorName = post.author?.name || "Redaksi ABADI.NEWS";
  
  const formattedDate = post?.date 
    ? new Date(post.date).toLocaleDateString("id-ID", { 
        year: "numeric", 
        month: "short", 
        day: "2-digit" 
      }).toUpperCase()
    : "";

  const textContent = stripHtml(post?.content);
  const wordCount = textContent.split(/\s+/).filter(Boolean).length;
  const readTime = Math.max(1, Math.ceil(wordCount / 200));

  const viewCount = post?.meta?.post_views_count 
    || post?.meta?.views 
    || post?.meta?.wpb_post_views_count 
    || post?.meta?.pvc_views 
    || 0;

  return (
    <div className="abadi-single-news-meta mt-0 pt-0">
      <div className="flex flex-wrap gap-2 md:gap-4 items-center text-xs md:text-sm text-slate-500 h-8 md:h-10">
        <span>{authorName}</span>
        <span>•</span>
        <span>{formattedDate}</span>
        <span>•</span>
        <span>{readTime} MENIT BACA</span>
        <span>•</span>
        <span>{viewCount} KALI</span>
      </div>

      {post.customFields?.rating && (
        <div className="abadi-single-news-rating mt-4 flex items-center gap-3 p-4 border border-orange-100 rounded-lg bg-orange-50/30">
          <div className="abadi-single-news-rating-main text-2xl font-bold text-orange-600">
            {post.customFields.rating}
          </div>
          <div className="abadi-single-news-rating-sub text-xs uppercase tracking-widest text-slate-600 font-medium">
            Rating Pembaca <br /> Berdasarkan Kualitas Konten
          </div>
        </div>
      )}
    </div>
  );
}

export default function ArticleMetaInfoSection({ post }: ArticleMetaInfoProps) {
  return (
    <section
      id="articlemetainfo"
      className="relative bg-white text-black py-12 overflow-hidden"
    >
      <div className="relative max-w-[1320px] mx-auto px-6 md:px-10 lg:px-16">
        <ArticleMetaInfo post={post} />
      </div>
    </section>
  );
}